<template>
    <div class="px-5">
        <v-row class="row-dashboard-power-bi mt-7">
        <v-overlay absolute :value="downloading" color="white" opacity="0.3" z-index="9">
            <v-progress-circular indeterminate color="#1DBC97" size="100" width="8"></v-progress-circular>
        </v-overlay>
            <v-col cols="12" md="auto" lg="auto" class="px-0 py-0">
                <v-row class="row-dashboard-power-bi text-head-dashboard-power-bi">
                    DASHBOARD PETTY
                </v-row>
                <v-row class="row-dashboard-power-bi text-head-dashboard-power-bi">
                    ITEM
                </v-row>
            </v-col>
            <v-spacer></v-spacer>
             <!-- temp comment -->
            <v-col cols="auto" md="auto" lg="auto" class=" pa-0 padding-btn-refresh-dashboard-power-bi" align-self="end">
                <v-btn @click="refresh()" height="40" depressed class="rounded-lg  btn-refresh-dashboard-power-bi" color="#1DBC97" >
                    <v-icon small class="mr-2" color="#1DBC97">mdi-refresh</v-icon>
                    <span class="font-text-refresh-dashboard-power-bi">Refresh ข้อมูล Power BI</span>
                </v-btn>
            </v-col> 
        </v-row>
        <v-row justify="end" class="row-dashboard-power-bi text-showdate-itembi mt-2">{{message}}</v-row>
        <v-card class="mt-3 card-radius-dashboard-power-bi card-height-dashboard-power-bi pt-5 px-0 pb-0" color="white"
            elevation="0">
            <iframe id="iframeid1" title="PB_Prd_test" width="100%" height="100%" :src="all_powerbi" frameborder="0" allowFullScreen="true"></iframe>
        </v-card>
    </div>
</template>

<script>
export default {
    data: () => ({
        all_powerbi : '',
        dataset_list:[],
        success_count:0,
        id:'',
        message:'',
        downloading:false
    }),
    mounted() {
        this.getPowerBi()
    },
    methods: {
        async getPowerBi() {
        this.downloading = true
        try {
          let tax_id = '0107544000094'
          const url = `/petty_cash/api/v1/id_powerbi?tax_id=${tax_id}`
          const { data } = await this.axios.get(this.$api_url + url)
          if(data.status){
            this.all_powerbi = data.data[0].iframe_list[0]
            this.dataset_list = data.data[0].dataset_list
            this.id = data.data[0]._id
            //----- เรียกฟังก์ชั่น วันที่อัปเดตข้อมูลล่าสุด -----//
            this.getDatasetHistory(this.dataset_list[0])
          }
        } catch (error) {
          console.log(error)
        }finally{
            this.downloading = false
        }
      },
      async refresh() {
        this.downloading = true
        try {
            const url = `/petty_cash/api/v1/refresh_powerbi`
            var { data } = await this.axios.post(this.$api_url + url, {
                dataset_list:this.dataset_list,
                date:new Date(),
                id:this.id
            })
            if(data.status){
                this.success_count = data.result
                this.getDatasetHistory(this.dataset_list[0])
                document.getElementById('iframeid1').src += ''
            }else{
                this.message = data.message
            }
        } catch (error) {
          console.log(error)
        }
        finally{
            this.downloading = false
        }
      },
        async getDatasetHistory() {
        try {
            const url = `/petty_cash/api/v1/get_history_dataset`
            var { data } = await this.axios.post(this.$api_url + url, {
                dataset_id:this.dataset_list[0]
            })
            if(data.status){
                this.message = `วันที่อัปเดตข้อมูลล่าสุด : ${this.$options.filters.shortmonthyearandtime(data.result[0].endTime)}`
                //this.message = `${this.message.substring(0,10).split('-')[2]}/${this.message.substring(0,10).split('-')[1]}/${this.message.substring(0,10).split('-')[0]}`
            }
        } catch (error) {
          console.log(error)
        }
      }
    }
}
</script>

<style>
.card-height-dashboard-power-bi {
    height: calc(100vh - 233px) !important;
}

.row-dashboard-power-bi {
    width: 100% !important;
    margin: 0% !important;
}

.text-head-dashboard-power-bi {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 24px !important;
    color: black;
}

.card-radius-dashboard-power-bi {
    border-radius: 15px !important;
}
.btn-refresh-dashboard-power-bi {
    background-color: white !important;
  }
.font-text-refresh-dashboard-power-bi {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #1DBC97;
    text-transform: capitalize;
  } 
  .text-showdate-itembi {
     font-family: 'Noto Sans Thai', sans-serif;
    font-size: 12px !important;
    color: black;
  }
  
@media only screen and (max-width:600px) {
    .card-height-dashboard-power-bi {
        height: calc(100vh - 272px) !important;
    }
    .padding-btn-refresh-dashboard-power-bi {
      margin-left: auto;
    }
}
</style>